import React, { useEffect, useState } from "react";
import { fetchMyPostedRides } from "../utils/api";
import PostRideCard from "./PostRideCard";
import AdBanner from "./ads/AdBanner"; // ✅ Imported AdBanner
import "../css/postcard.css";

export default function PreviousRides({ user }) {
  const [rides, setRides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  
  const userId = user?.id || user?._id;

  const loadRides = async () => {
    const token = localStorage.getItem("travelo_token");
    if (!userId || !token) {
      setRides([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError("");
      
      const response = await fetchMyPostedRides(userId, token);
      
      let ridesArray = [];
      if (Array.isArray(response)) {
        ridesArray = response;
      } else if (response?.rides && Array.isArray(response.rides)) {
        ridesArray = response.rides;
      } else if (response?.data && Array.isArray(response.data)) {
        ridesArray = response.data;
      }

      const sortedRides = ridesArray.sort((a, b) => {
        const dateA = new Date(a.date || a.createdAt).getTime();
        const dateB = new Date(b.date || b.createdAt).getTime();
        return dateB - dateA;
      });

      setRides(sortedRides);
    } catch (err) {
      console.error("PreviousRides error:", err);
      setError("Could not load your previous rides.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRides();
  }, [userId]);

  return (
    <section className="pr-section">
      <div className="pr-header-row">
        <h2 className="pr-section-title">🚗 Your Posted Rides</h2>
        <span className="pr-count-badge">{rides.length} Rides</span>
      </div>

      {loading ? (
        <div className="pr-state loading">
          <div className="pr-spinner"></div>
          Loading your rides...
        </div>
      ) : error ? (
        <div className="pr-state error">{error}</div>
      ) : rides.length === 0 ? (
        <div className="pr-state empty">
          <span className="empty-icon">🛣️</span>
          <h3>No Rides Posted</h3>
          <p>You haven't posted any rides yet.</p>
          {/* ✅ AD IN EMPTY STATE */}
          <div style={{ marginTop: "30px", width: "100%" }}>
            <AdBanner type="inline" />
          </div>
        </div>
      ) : (
        <div className="pr-grid">
          {rides.map((ride, index) => (
            <React.Fragment key={ride._id || ride.id || index}>
              <PostRideCard 
                ride={ride} 
                onRefresh={loadRides} 
              />
              
              {/* ✅ IN-FEED AD: Shows after every 4th ride */}
              {(index + 1) % 4 === 0 && (
                <div style={{ 
                  gridColumn: "1 / -1", 
                  margin: "15px 0",
                  display: "flex", 
                  flexDirection: "column", 
                  alignItems: "center" 
                }}>
                  <span style={{ fontSize: "10px", color: "#94a3b8", fontWeight: "700", textTransform: "uppercase", marginBottom: "4px", alignSelf: "flex-start" }}>
                    Sponsored
                  </span>
                  <AdBanner type="inline" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </section>
  );
}